import dayjs from "dayjs";

export const thirteenYearsAgo = dayjs().subtract(13, "years");

// This regex will match phone numbers in formats like (123) 456-7890, 123-456-7890, or 1234567890
export const phoneNumberRegex = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/;